"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectoryRow = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const directory_row_style_1 = __importDefault(require("./directory.row.style"));
class DirectoryRow extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes } = this.props;
            const { main, cell1, cell2, cell3, isLast } = this.props;
            return (jsx_runtime_1.jsxs("section", Object.assign({ className: isLast ? classes.borderBottom : classes.root }, { children: [main && jsx_runtime_1.jsx("div", Object.assign({ className: classes.main }, { children: main }), void 0),
                    cell3 && jsx_runtime_1.jsx("div", Object.assign({ className: classes.cell3 }, { children: cell3 }), void 0),
                    cell2 && jsx_runtime_1.jsx("div", Object.assign({ className: classes.cell2 }, { children: cell2 }), void 0),
                    cell1 && jsx_runtime_1.jsx("div", Object.assign({ className: classes.cell1 }, { children: cell1 }), void 0)] }), void 0));
        };
    }
}
exports.DirectoryRow = DirectoryRow;
DirectoryRow.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    isLast: prop_types_1.default.bool,
    main: prop_types_1.default.node.isRequired,
    cell1: prop_types_1.default.node,
    cell2: prop_types_1.default.node,
    cell3: prop_types_1.default.node
};
DirectoryRow.defaultProps = {
    cell1: null,
    cell2: null,
    cell3: null,
    isLast: null
};
exports.default = react_jss_1.default(directory_row_style_1.default)(DirectoryRow);
//# sourceMappingURL=directory.row.js.map